import React from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import s from './Created.module.scss'

import { InfoIcon } from 'assets/icons/InfoIcon'
import { LockIcon } from 'assets/icons/LockIcon'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'

const Created = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const { pin } = useParams()

  const onHide = () => {
    navigate(`../?${searchParams}`, { replace: true })
  }
  return (
    <ModalFullScreen onHide={onHide} className={s.modalWrapper}>
      <div className={s.headerWrapper}>
        <h1 className={s.header}> Ad Space Created </h1>
        <p className={s.text}>You need to verify it in metaverse using the PIN bellow:</p>
        <a className={s.link} href="https://discord.gg/fsQ7xJf8Rn" target="_blank" rel="noreferrer">
          <InfoIcon className={s.infoIcon} /> How to do it?
        </a>
      </div>
      <div className={s.pinWrapper}>
        <LockIcon className={s.lockIcon} />
        <h2 className={s.modalTitle}>{pin}</h2>
      </div>
      <div className={s.buttonsWrapper}>
        <CustomButton
          variant="secondary"
          type="button"
          onClick={(e) => {
            navigator.clipboard.writeText(pin || '')
            onHide()
          }}
          size="240"
          className={s.gotItBtn}
        >
          Got it!
        </CustomButton>
        <CustomButton variant="outlined" type="button" onClick={onHide} size="152">
          Close
        </CustomButton>
      </div>
    </ModalFullScreen>
  )
}

export default Created
